import React from 'react';
import {Badge, IconButton, Tooltip, useMediaQuery} from '@mui/material';
import {useSelector} from 'react-redux';
import {RootState} from '../../store';
import {useNavigate} from 'react-router-dom';
import {AttachMoney} from "@mui/icons-material";

const NavBarAdminActionableTransaction = () => {
    const navigate = useNavigate();
    const isSmUp = useMediaQuery('(min-width:640px)');
    const actionableTransactions = useSelector((state: RootState) => state.admin.actionableTransaction || 0);

    if (actionableTransactions === 0 || !isSmUp) {
        return null;
    }

    return (
        <Tooltip title="Actionable Transactions">
            <IconButton
                onClick={() => navigate('/admin/trades')}
                size="medium"
                sx={{
                    height: 40,
                    width: 40,
                    color: 'warning.contrastText',
                    backgroundColor: 'warning.main',
                    border: '1px solid',
                    borderColor: 'warning.main',
                    borderRadius: '8px',
                    '&:hover': {
                        backgroundColor: 'warning.main',
                    },
                }}
            >
                <Badge badgeContent={actionableTransactions > 99 ? '99+' : actionableTransactions} color="error">
                    <AttachMoney />
                </Badge>
            </IconButton>
        </Tooltip>
    );
};

export default NavBarAdminActionableTransaction;